// Logo corporatiu del tenant (el mateix que el menú): el de la web, el fiscal
// o, com a últim recurs, el de BedLoop.
const urlLogo = (config, ruta) => {
    if (config && config.logo) return ruta + "/web/logo/web/" + config.logo;
    if (config && config.logo_fiscal) return ruta + "/web/logo/" + config.logo_fiscal;
    return "https://www.bedloop.com/imatges/logo.webp";
};

export default urlLogo;
